/**
 * useSyncedRecipes — wraps saveRecipe / unsaveRecipe with Supabase sync.
 * Use this instead of calling useAppStore().saveRecipe directly.
 */
import { useAppStore } from '@/hooks/useAppStore';
import { useAuth } from '@/hooks/useAuth';
import { saveRecipeToSupabase, deleteRecipeFromSupabase } from '@/hooks/useUserSync';
import type { Meal } from '@/lib/index';

export function useSyncedRecipes() {
  const { user } = useAuth();
  const { saveRecipe, unsaveRecipe, isRecipeSaved, savedRecipes } = useAppStore();

  const syncedSave = (meal: Meal, sourcePlan?: string) => {
    saveRecipe(meal, sourcePlan);              // local store
    if (user) saveRecipeToSupabase(user.id, meal, sourcePlan); // supabase
  };

  const syncedUnsave = (id: string) => {
    unsaveRecipe(id);                          // local store
    if (user) deleteRecipeFromSupabase(user.id, id); // supabase
  };

  return { saveRecipe: syncedSave, unsaveRecipe: syncedUnsave, isRecipeSaved, savedRecipes };
}
